import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";

const About = () => {
  const handleOpenMaps = () => {
    const mapUrl =
      "https://www.google.com/maps?q=Indian+Bank,+PPW2+GXQ,+Thachanallur,+Tirunelveli,+Tamil+Nadu+627358";
    window.open(mapUrl, "_blank");
  };

  return (
    <Wrapper>
      <Container>

        {/* ABOUT SECTION */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Heading>About LK Education</Heading>
          <Text>
            With <strong>years of proven experience</strong> in training, LK Education
            stands as one of the <strong>top accounting and Tally training institutes in Tirunelveli</strong>.
            <br /><br />
            We specialize in delivering <strong>job-ready, practical training</strong> with
            real-time examples, hands-on practice, and industry-based case studies.
            Every learner receives a <strong>Professional Certification</strong> upon completion
            and dedicated <strong>career guidance</strong> to help them build a successful future.
          </Text>
        </motion.div>

        {/* WHY CHOOSE US SECTION */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <SubHeading>Why Choose LK Education?</SubHeading>

          <ServicesGrid>
            {[
              "Years of Experience in Professional Training",
              "Provides Recognized Professional Certification",
              "Job-Ready Practical Training Approach",
              "Career Guidance & Placement Support",
              "Top Accounting & Tally Institute in Tirunelveli"
            ].map((item, index) => (
              <ServiceCard key={index}>
                <FaCheckCircle className="icon" />
                <p>{item}</p>
              </ServiceCard>
            ))}
          </ServicesGrid>
        </motion.div>

        {/* SERVICES SECTION */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <SubHeading>Our Training Programs</SubHeading>

          <ServicesGrid>
            {[
              "Tally Essentials & Tally Professional",
              "GST & TDS (Practical Filing Training)",
              "Payroll Management Using TallyPrime",
              "Accounting Basics Crash Course",
              "MS Office for Accountants",
              "Online / Offline Flexible Learning"
            ].map((item, index) => (
              <ServiceCard key={index}>
                <FaCheckCircle className="icon" />
                <p>{item}</p>
              </ServiceCard>
            ))}
          </ServicesGrid>
        </motion.div>

        {/* LOCATION MAP SECTION */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <SubHeading>Find Us Here</SubHeading>

          <MapContainer>
            <iframe
              title="LK Education Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3914.0215167593627!2d77.73790777477566!3d8.712334493706026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b0412333a7d95f7%3A0xc2df42c8d8299d85!2sIndian%20Bank%2C%20PPW2%2BGXQ%2C%20Thachanallur%2C%20Tirunelveli%2C%20Tamil%20Nadu%20627358!5e0!3m2!1sen!2sin!4v1736601123456"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </MapContainer>

          <MapButton onClick={handleOpenMaps}>
            📍 Open in Google Maps
          </MapButton>
        </motion.div>

      </Container>
    </Wrapper>
  );
};

export default About;

/* ---------------------------- STYLES ----------------------------- */

const Wrapper = styled.section`
  padding: 120px 20px;
  background: ${(props) => props.theme.colors.extralight};
`;

const Container = styled.div`
  max-width: 1100px;
  margin: auto;
`;

const Heading = styled.h1`
  text-align: center;
  font-size: 2.4rem;
  font-weight: 700;
  color: ${(props) => props.theme.colors.dark};
  margin-bottom: 20px;
`;

const SubHeading = styled.h2`
  text-align: center;
  font-size: 1.8rem;
  margin-top: 50px;
  margin-bottom: 25px;
  color: ${(props) => props.theme.colors.secondary};
`;

const Text = styled.p`
  text-align: center;
  max-width: 850px;
  margin: auto;
  font-size: 1.05rem;
  line-height: 1.9;
  color: #444;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
  margin-top: 30px;
`;

const ServiceCard = styled.div`
  background: #fff;
  padding: 18px 20px;
  border-radius: 18px;
  display: flex;
  gap: 12px;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.medium};
  box-shadow: 0 4px 12px rgba(0,0,0,0.07);
  transition: 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 10px 28px rgba(0,0,0,0.1);
  }

  .icon {
    color: ${(props) => props.theme.colors.secondary};
    font-size: 1.3rem;
  }

  p {
    font-size: 1rem;
    margin: 0;
    color: #333;
  }
`;

const MapContainer = styled.div`
  margin-top: 30px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0,0,0,0.1);

  iframe {
    width: 100%;
    height: 350px;
    border: none;
  }
`;

const MapButton = styled.button`
  margin: 25px auto 0 auto;
  display: block;
  padding: 14px 28px;
  font-size: 1.05rem;
  font-weight: 600;
  color: #fff;
  background: ${(props) => props.theme.colors.secondary};
  border: none;
  border-radius: 14px;
  cursor: pointer;
  transition: 0.3s ease;
  box-shadow: 0 4px 14px rgba(0,0,0,0.15);

  &:hover {
    background: ${(props) => props.theme.colors.dark};
    transform: translateY(-4px);
  }
`;
